import React from 'react';
import { Box } from '@mui/material';
import { info } from '../../assets/info/Info';
import styles from './Experience.module.scss';

export default function Experience() {
  return (
    <Box component={'main'} className={styles.experience}>
      <Box component={'ul'} className={styles.list}>
        {info.experience.map((exp, index) => (
          <Box component={'li'} key={index} className={styles.row}>
            <span className={styles.role}>
              {exp.link ? (
                <a
                  href={exp.link}
                  target={'_blank'}
                  rel={'noopener noreferrer'}
                  className={styles.link}
                >
                  {exp.company}
                </a>
              ) : (
                exp.company
              )}
              {' - '}
              {exp.title}
            </span>
            <span className={styles.date}>{exp.date}</span>
            {exp.description && <span className={styles.description}>{exp.description}</span>}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
